import React, { useState, useEffect } from "react";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useGuestChatSession } from "@/hooks/chat/useGuestChatSession.js";
import GuestChatDrawer from "@/components/chat/GuestChatDrawer.jsx";

const GuestChatButton = ({ guestInfo, className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleOpenChat = () => setIsOpen(true);
    window.addEventListener("hotel:openGuestChat", handleOpenChat);
    return () => window.removeEventListener("hotel:openGuestChat", handleOpenChat);
  }, []);

  const { unreadCount } = useGuestChatSession({
    guestInfo,
    defaultDepartment: "Reception",
  });

  return (
    <>
      <Button
        type="button"
        size="sm"
        onClick={() => setIsOpen(true)}
        disabled={!guestInfo?.sessionId}
        className={`relative gap-2 rounded-xl border border-white/20 bg-white/10 text-slate-900 shadow-sm backdrop-blur-md hover:bg-white/20 transition-all ${className}`}
      >
        <MessageSquare className="h-4 w-4 text-[#923536]" />
        <span>Message</span>
        {unreadCount > 0 && (
          <span className="absolute -right-1 -top-1 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-[#923536] px-1 text-[10px] font-bold text-white shadow-sm ring-1 ring-white animate-pulse">
            {unreadCount}
          </span>
        )}
      </Button>

      <GuestChatDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        guestInfo={guestInfo}
      />
    </>
  );
};

export default GuestChatButton;
